import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ed51408"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex-ter" }
const _hoisted_5 = { class: "flexcenter" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "flex-ter-bwn"
}
const _hoisted_8 = { class: "order-tag flex-center" }

import { t } from '@/plugins/i18n'
import { ref, watch, computed } from 'vue'
import STable from '@/components/Table/index.vue'
import AppLink from '@/components/common/AppLink.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { BDialogChildColumns, BDialogTableConfig } from './data'
import { inLogInfoDetail } from '@/apis/order'
import { getJapanTime } from '@/util/common'
import ProductStats from '../components/ProductStats.vue'
import ProductSku from '../components/ProductSku.vue'
import { getTrack } from '@/apis/inShipping'
import TrackDialog from '@/views/inshipping/ShippingList/TrackDialog/index.vue'
import CopyButton from '@/components/common/CopyButton.vue'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  rowItem: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props

const tableData = computed(() => {
  console.log(props.rowItem)
  return [props.rowItem]
})

const columns: any = [
  {
    label: t('发货单号'),
    prop: 'deliveryTaskCode'
  },
  {
    label: t('物流公司'),
    prop: 'distribution'
  },
  {
    label: t('国际物流单号'),
    prop: 'logisticsCode',
    align: 'center',
    slotName: 'logisticsCode'
  },
  {
    label: t('国际运费'),
    prop: 'freightFee',
    align: 'center',
    slotName: 'freightFee'
  },
  {
    label: t('计费重量') + '(g)',
    prop: 'weight',
    align: 'center'
  },
  {
    label: t('发货时间'),
    prop: 'deliveryTime',
    align: 'center',
    slotName: 'deliveryTime'
  },
  {
    label: t('发货数量'),
    prop: 'deliveryNums',
    align: 'center'
  }
]

const childColumns: any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    slotName: 'platformOrderNo'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 250,
    align: 'center',
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    width: 180,
    align: 'center'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    width: 180,
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('下单数量'),
    prop: 'deliveryNums',
    align: 'center'
  }
  // {
  //   label: t('商品状态'),
  //   align: 'center',
  //   width: 160,
  //   slotName: 'shoppingStats'
  // }
]



const apiConfig = {
  listPath: 'data'
}
const trackVisible = ref(false)
const trackInfo: any = ref({})
const showTrack = (row: any) => {
  getTrack({
    deliveryTaskCode: row.deliveryTaskCode,
    logisticsCode: row.logisticsCode
  }).then((res: any) => {
    console.log(res)
    trackInfo.value = res.data
  }).finally(() => { trackVisible.value = true })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "model-value": __props.visible,
      "destroy-on-close": "",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false))),
      draggable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(STable, {
            api: _unref(inLogInfoDetail),
            columns: columns,
            "filter-data": { platformOrderId: __props.rowItem.platformOrderId },
            tableConfig: _unref(BDialogTableConfig),
            "api-config": apiConfig,
            "show-pagination": false
          }, {
            expand: _withCtx(({ scope }) => [
              _createVNode(STable, {
                tableData: scope.row.platformOrderItemList,
                columns: childColumns,
                showPagination: false
              }, {
                platformOrderNo: _withCtx(({ row }) => [
                  (row.platformOrderId)
                    ? (_openBlock(), _createBlock(AppLink, {
                        key: 0,
                        to: '/d2c/order/OrderInfo/' + row.platformOrderId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.platformOrderNo), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.platformOrderNo), 1))
                ]),
                shoppingInfo: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(ShoppingPreview, {
                      image: row.productSkuImg || row.productMainImg || '',
                      name: row.productTitleJp || '',
                      url: row.productDetailUrl || undefined
                    }, null, 8, ["image", "name", "url"])
                  ])
                ]),
                productSku: _withCtx(({ row }) => [
                  row
                    ? (_openBlock(), _createBlock(ProductSku, {
                        key: 0,
                        row: row
                      }, null, 8, ["row"]))
                    : _createCommentVNode("", true)
                ]),
                productPropertiesName: _withCtx(({ row }) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                    return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                  }), 128))
                ]),
                shoppingStats: _withCtx(({ row }) => [
                  _createVNode(ProductStats, { row: row }, null, 8, ["row"])
                ]),
                cancel: _withCtx(({ row }) => [
                  _createVNode(_component_el_input, {
                    modelValue: row.orderQuantity,
                    "onUpdate:modelValue": ($event: any) => ((row.orderQuantity) = $event),
                    disabled: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["tableData"])
            ]),
            deliveryTime: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.deliveryTime ?? '')), 1)
            ]),
            logisticsCode: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (showTrack(row)),
                  style: {"flex":"1"}
                }, _toDisplayString(row.logisticsCode), 9, _hoisted_6),
                _createVNode(CopyButton, {
                  text: row.logisticsCode
                }, null, 8, ["text"])
              ])
            ]),
            orderId: _withCtx(({ row }) => [
              (row.isMergeOrder)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(AppLink, {
                      to: '/d2c/user/OrderInfo/' + row.shippingId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.orderId), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('合')), 1)
                  ]))
                : (_openBlock(), _createBlock(AppLink, {
                    key: 1,
                    to: '/d2c/user/OrderInfo/' + row.orderId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.orderId), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ]),
            shippingId: _withCtx(({ row }) => [
              _createVNode(AppLink, {
                to: '/d2c/user/OrderInfo/' + row.shippingId
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.shippingId), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            freightFee: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(showCurrentUnit)(row.platformOrderItemList?.[0]?.goodsCountry === _unref(COUNTRY).KR, row.freightFee)), 1)
            ]),
            _: 1
          }, 8, ["api", "filter-data", "tableConfig"])
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(TrackDialog, {
      visible: trackVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((trackVisible).value = $event)),
      rowItem: trackInfo.value
    }, null, 8, ["visible", "rowItem"])
  ], 64))
}
}

})